export const SETUP_CALL_MODAL_PATH = 'setup-call';
